<div class="st-page">
  <div class="sco-hero-card" *ngIf="!loading || className">
    <div class="sco-hero-glow"></div>
    <div class="sco-hero-left">
      <div class="sco-hero-top-row">
        <button class="sco-back-btn" (click)="goBack()"><i class="ri-arrow-left-s-line"></i></button>
        <div class="sco-hero-badge"><i class="ri-grid-line"></i> {{ 'staffClassOverviewBadge' | translate }}</div>
      </div>
      <h2 class="sco-hero-title">{{ className }} &ndash; {{ section }}</h2>
      <div class="sco-hero-teacher" *ngIf="classTeacherName">
        <span class="sco-hero-dot"></span> {{ 'classTeacher' | translate }} &middot; {{ classTeacherName }}
      </div>

      <div class="sco-stat-row">
        <div class="sco-stat-box">
          <span class="sco-stat-label">{{ 'total' | translate }}</span>
          <span class="sco-stat-value">{{ displayTotalStudents }}</span>
        </div>
        <div class="sco-stat-box">
          <span class="sco-stat-label"><span class="sco-stat-dot sco-dot-green"></span>{{ 'present' | translate }}</span>
          <span class="sco-stat-value">{{ displayPresentCount }}</span>
        </div>
        <div class="sco-stat-box">
          <span class="sco-stat-label"><span class="sco-stat-dot sco-dot-red"></span>{{ 'absent' | translate }}</span>
          <span class="sco-stat-value">{{ displayAbsentCount }}</span>
        </div>
        <div class="sco-stat-box">
          <span class="sco-stat-label"><span class="sco-stat-dot sco-dot-yellow"></span>{{ 'late' | translate }}</span>
          <span class="sco-stat-value">{{ displayLateCount }}</span>
        </div>
        <div class="sco-stat-box">
          <span class="sco-stat-label"><span class="sco-stat-dot sco-dot-purple"></span>{{ 'leave' | translate }}</span>
          <span class="sco-stat-value">{{ displayLeaveCount }}</span>
        </div>
      </div>
    </div>

    <div class="sco-hero-right">
      <div class="sco-gauge" [style.background]="'conic-gradient(from 0deg, var(--brand-primary-color) 0deg, var(--accent-purple) ' + (displayAttendancePercent * 3.6) + 'deg, rgba(255,255,255,0.12) ' + (displayAttendancePercent * 3.6) + 'deg)'">
        <div class="sco-gauge-inner">
          <span class="sco-gauge-value">{{ displayAttendancePercent }}%</span>
          <span class="sco-gauge-label">{{ currentMonthLabel }}</span>
        </div>
      </div>
      <button class="sco-students-link-btn" (click)="openStudentsList()">
        {{ 'viewStudentsList' | translate }} <i class="ri-arrow-right-s-line"></i>
      </button>
    </div>
  </div>

  <div class="st-empty-state" *ngIf="loading && !className">
    <i class="ri-loader-4-line ri-spin"></i> {{ 'loadingClass' | translate }}
  </div>

  <div class="st-empty-state" *ngIf="!loading && loadError && !className">
    <i class="ri-error-warning-line"></i> {{ 'couldNotLoadClassTryAgain' | translate }}
  </div>

  <h2 class="sco-section-title">{{ 'classTools' | translate }}</h2>

  <div class="sco-tile-grid">
    <div class="sco-tile" *ngFor="let t of visibleTiles" (click)="openTile(t.key)">
      <div class="sco-tile-top">
        <div class="sco-tile-icon" [ngClass]="'sco-tile-icon-' + t.color"><i [ngClass]="t.icon"></i></div>
        <div class="sco-tile-arrow-btn"><i class="ri-arrow-right-up-line"></i></div>
      </div>
      <span class="sco-tile-label">{{ t.label | translate }}</span>
      <span class="sco-tile-subtitle">{{ t.subtitle | translate }}</span>
    </div>
  </div>
</div>
